var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovedMemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#36A6A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10996 11.4368C7.94196 11.4368 7.77396 11.3731 7.64571 11.2448L5.86596 9.46508C5.60946 9.20858 5.60946 8.79308 5.86596 8.53733C6.12246 8.28083 6.53721 8.28008 6.79371 8.53658L8.10996 9.85283L11.206 6.75683C11.4625 6.50033 11.8772 6.50033 12.1337 6.75683C12.3902 7.01333 12.3902 7.42883 12.1337 7.68533L8.57421 11.2448C8.44596 11.3731 8.27796 11.4368 8.10996 11.4368Z",
    fill: "#36A6A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedMemIcon);
export default __webpack_public_path__ + "static/media/approvedMemIcon.43091b32c776c2ff042061c662d1ce2f.svg";
export { ForwardRef as ReactComponent };